<template>
    <VAppLayout>
        <VAppTitle :title="$t('pages.menu.title')">
            <VAppLocale @update:value="pullFullMenu(true)" />
        </VAppTitle>
        
        <MenuCategorySelect :categories="comCategories" :selectedCategory="selectedCategory" />
        <MenuHorizontalScroll v-if="comPopular !== null" :id="comPopular.id" :title="comPopular.name"
            :items="comPopular.items" ref="popularRef" />
        <VContainer>
          <VAlert
              v-if="shouldShowAlert"
              v-model="alert.show"
              :type="alert.type"
              :text="alertText"
              :dismissible="false"
              :html="alert.html"
          />

            <MenuInfScroll @loadedItems="addObserveElements" />
        </VContainer>
    </VAppLayout>
</template>

<script>
import VAppLayout from "@/layouts/VAppLayout.vue";
import VContainer from "@/components/ui/VContainer.vue";
import VAppTitle from "@/components/ui/VAppTitle.vue";
import VAppLocale from "@/components/ui/VAppLocale.vue";
import VAlert from "@/components/ui/VAlert.vue";
import MenuCategorySelect from "./components/MenuCategorySelect.vue";
import MenuInfScroll from "./components/MenuInfScroll.vue";
import MenuHorizontalScroll from "./components/MenuHorizontalScroll.vue";

export default {
    name: "MenuTabNew",
    components: {
        VAppLayout,
        VContainer,
        VAppTitle,
        VAppLocale,
        VAlert,
        MenuCategorySelect,
        MenuInfScroll,
        MenuHorizontalScroll,
    },
    data() {
        return {
            observer: null,
            selectedCategory: "",
            firstCategory: null,
            alert: {
                show: true,
                type: 'warning',
                text: '',
                html: true
            }
        };
    },
    created() {
        this.observer = new IntersectionObserver(
            this.onElementObserved,
            {
                root: this.$el,
                rootMargin: '-25% 0% -75% 0%',
                threshold: 0,
            }
        );

        this.pullFullMenu(true);
    },
    beforeDestroy() {
        this.observer.disconnect();
    },
    computed: {
        comMenu() {
            return this.$store.getters['menuStore/getMenu'] || [];
        },
        comPopular() {
            return this.$store.getters['menuStore/getPopular'] || null;
        },
        comCategories() {
            const res = [];

            if (this.comPopular !== null) {
                res.push({ id: this.comPopular.id, name: this.comPopular.name });
            }
            const categories = this.comMenu.map(c => ({ id: c.id, name: c.name }));

            return res.concat(categories);
        },
        companyData() {
            return this.$store.getters['getCompanyData'] || {};
        },
        shouldShowAlert() {
            return this.companyData.locale && this.companyData.locale.pos_terminal_enabled === 0 && !this.$store.getters['getIsModeWMM'];
        },
        alertText() {
            const title = this.$t('alerts.orders_disabled.title');
            const message = this.$t('alerts.orders_disabled.message');
            return `<span style="font-weight:600">${title}</span><br>${message}`;
        }
    },
    methods: {
        addObserveElements(elements) {
            if (Array.isArray(elements)) {
                elements.forEach(element => {
                    this.observer.observe(element);
                })
            }
        },
        onElementObserved(entries) {
            entries.forEach(({ target, isIntersecting }) => {
                if (isIntersecting) {
                    this.selectedCategory = target.id;
                }
            });
        },
        pullFullMenu(forceUpdate) {
            this.$store.dispatch('menuStore/GET_FULL_MENU', forceUpdate).then(() => this.afterMenuLoad());
        },
        afterMenuLoad() {
            if (this.firstCategory !== null) {
                this.firstCategory.classList.remove("first-category");
            }
            const observeElements = [];

            if (this.comPopular !== null) {
                const el = this.$refs.popularRef.$el;
                observeElements.push(el);
                if (this.firstCategory === null) {
                    this.firstCategory = el;
                }
            }
            this.addObserveElements(observeElements);

            if (this.firstCategory === null && this.comMenu.length !== 0) {
                const escapeId = CSS.escape(this.comMenu[0].id);
                this.firstCategory = this.$el.querySelector(`#${escapeId}`) || null;
            }

            if (this.firstCategory !== null) {
                this.firstCategory.classList.add("first-category");
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.app_title {
    box-sizing: border-box;
    padding: 0 16px;
}

::v-deep .first-category {
    scroll-margin-top: 100vh;
}
</style>
